import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary Завершить сессию входа по почте
 */
export const LogoutB2BEmailLoginContentType = '' as const;
export type LogoutB2BEmailLoginRequest = void;
export type LogoutB2BEmailLoginResponses = LinkCommonErrorResponses & {
    /**
     * @description Вход по почте выключен
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type LogoutB2BEmailLoginResponseSuccess = undefined;
export type LogoutB2BEmailLoginSearchParams = undefined;
export type LogoutB2BEmailLoginPathParameters = undefined;
export const LogoutB2BEmailLoginUrl = '/auth/email/logout' as const;
export const LogoutB2BEmailLoginMethod = 'POST' as const;
export const getLogoutB2BEmailLoginUrl = (_params?: LogoutB2BEmailLoginPathParameters) => LogoutB2BEmailLoginUrl;
